module.exports = __webpack_public_path__ + "img/rule_bet.12856156.png";